export enum EpSelfEnrolmentFlowStepEnum {
  EmployerInformation,
  ContactPersonnel
}
